import type { ChangeEvent } from 'react';

type RadioButtonProps = {
  currentlySelected: string;
  name: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
};

const RadioButton = ({
  currentlySelected,
  name,
  onChange
}: RadioButtonProps) => (
  <label>
    <input
      type="radio"
      checked={currentlySelected === name}
      name={name}
      value={name}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onChange={onChange}
    />
    {name}
  </label>
);

export { RadioButton };
